import { render } from "./goods.vue?vue&type=template&id=482ba200&scoped=true"
import script from "./goods.vue?vue&type=script&lang=js"
export * from "./goods.vue?vue&type=script&lang=js"

import "./goods.vue?vue&type=style&index=0&id=482ba200&lang=scss&scoped=true"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-482ba200"]])

export default __exports__